"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
var header_1 = require("../constants/form/header");
var tailwind_1 = require("../constants/tailwind");
var search_product_form_1 = require("../modules/search_product_form");
var get_element_1 = require("../utils/get_element");
var contents_1 = require("../constants/form/contents");
/**
 * ヘッダー検索フォーム要素群
 */
var headerSearchElements = {
    form: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.FORM),
    warningOptions: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.WARNING_OPTIONS),
    laserOptions: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_OPTIONS),
    laserSubOptions: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_SUB_OPTIONS),
    childSymbolMark: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.CHILD_SYMBOL_MARK),
    childSymbolMarkArrow: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.CHILD_SYMBOL_MARK_ARROW),
    resetButton: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.RESET_BUTTON),
    laserClassRanksContainer: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_CLASS_RANKS_CONTAINER),
    laserTypesContainer: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_TYPES_CONTAINER),
    laserWavelengthContainer: (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_WAVELENGTH_CONTAINER),
};
// レーザクラスカテゴリIDはTwigからwindow.eccube.productCategoryIds.laserClassTypeで取得
var categoryLaserClassTypeId = (_b = (_a = window.eccube) === null || _a === void 0 ? void 0 : _a.productCategoryIds) === null || _b === void 0 ? void 0 : _b.laserClassType;
/**
 * 詳細検索ボタンクリックイベント
 */
var initSearchToggleButtonEvent = function () {
    var toggleOptionButton = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.TOGGLE_OPTION_BUTTON);
    var options = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.OPTIONS);
    var laserRadioButton = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_BUTTON);
    toggleOptionButton.addEventListener('click', function () {
        options.classList.toggle(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    });
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var productTypeValue = urlParams.get('product_type');
    if (productTypeValue == categoryLaserClassTypeId) {
        headerSearchElements.laserSubOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    }
    laserRadioButton.addEventListener('click', function () {
        headerSearchElements.laserSubOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    });
};
/**
 * ヘッダー検索フォームイベント関連のコールバック
 */
var HEADER_SEARCH_CALLBACKS = {
    onProductTypeChange: function () {
        var searchButton = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.SEARCH_BUTTON);
        var productTypeAnnotation = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.PRODUCT_TYPE_ANNOTATION);
        searchButton.classList.remove(header_1.HEADER_SEARCH_CLASSES.BUTTON_DISABLED);
        searchButton.disabled = false;
        productTypeAnnotation.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    },
    onReset: function () {
        var warningOptions = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.WARNING_OPTIONS);
        var laserOptions = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.LASER_OPTIONS);
        var productTypeAnnotation = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.PRODUCT_TYPE_ANNOTATION);
        var searchButton = (0, get_element_1.getElementById)(header_1.HEADER_SEARCH_IDS.SEARCH_BUTTON);
        warningOptions.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        laserOptions.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        productTypeAnnotation.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        searchButton.classList.add(header_1.HEADER_SEARCH_CLASSES.BUTTON_DISABLED);
        searchButton.disabled = true;
    },
};
var categoryLaserLabelId = (_d = (_c = window.eccube) === null || _c === void 0 ? void 0 : _c.productCategoryIds) === null || _d === void 0 ? void 0 : _d.laserLabel;
/**
 * ヘッダー検索フォームの初期化
 */
var categoryWarningLabelId = (_f = (_e = window.eccube) === null || _e === void 0 ? void 0 : _e.productCategoryIds) === null || _f === void 0 ? void 0 : _f.warningLabel;
document.addEventListener('DOMContentLoaded', function () {
    initSearchToggleButtonEvent();
    var headerSearchForm = new search_product_form_1.SearchProductForm(headerSearchElements, HEADER_SEARCH_CALLBACKS);
    // ページ表示時にフォームをリセット
    headerSearchForm['handleResetButtonClick']();
    var url = window.location.pathname;
    var urlParams = new URLSearchParams(window.location.search);
    if (url === '/products/list' && urlParams.get('product_type') === categoryLaserLabelId) {
        // data-value="16001" のボタンからアクティブクラスを外す
        var defaultBtn = document.querySelector('[data-value="' + categoryWarningLabelId + '"]');
        if (defaultBtn) {
            defaultBtn.classList.remove(tailwind_1.TAILWIND_CLASSES.SEARCH_TAB_BUTTON_ACTIVE);
        }
        var btn = document.getElementById(contents_1.CONTENTS_SEARCH_IDS.LASER_LABEL_BUTTON);
        if (btn) {
            btn.classList.add(tailwind_1.TAILWIND_CLASSES.SEARCH_TAB_BUTTON_ACTIVE);
            btn.click();
        }
    }
});
